import update from 'immutability-helper';
import cloneDeep from 'lodash/cloneDeep';
import * as types from './types';

const initialRule = {
  operator: 'equals',
  value: '',
};

const initialState = {
  visible: false,
  newConfigPanel: {
    name: '',
    rules: [{ ...initialRule }],
    id: 0,
    state: 2,
  },
};

const reducerMap = {};

reducerMap[types.ADD_OR_RULE] = state => update(state, {
  newConfigPanel: {
    rules: {
      $push: [{ ...initialRule }],
    },
  },
});

reducerMap[types.UPDATE_OR_RULE] = (state, action) => {
  const { index, payload } = action;
  const rule = cloneDeep(state.newConfigPanel.rules);
  const [idx1] = index.split('-');
  Object.assign(rule[idx1], payload);
  return update(state, {
    newConfigPanel: {
      rules: {
        [idx1]: {
          $merge: payload,
        },
      },
    },
  });
};

reducerMap[types.DELETE_OR_RULE] = (state, action) => {
  const { index } = action;
  const newState = update(state, {
    newConfigPanel: {
      rules: {
        $splice: [[index, 1]],
      },
    },
  });
  return newState;
};

reducerMap[types.UPDATE_CONFIG_CONDITIONS] = (state, action) => update(state, {
  newConfigPanel: { $merge: action.payload },
});

reducerMap[types.CHANGE_CONFIG_CONTAINER_VISIBILITY] = (state, action) => {
  const { visible } = action;
  if (visible === false) {
    return update(state, {
      $merge: {
        visible: false,
        newConfigPanel: { ...initialState.newConfigPanel },
      },
    });
  }
  return update(state, {
    visible: { $set: true },
  });
};

reducerMap[types.CLEAR_CONFIG_FORM] = state => update(state, {
  $set: {
    newConfigPanel: { ...initialState.newConfigPanel },
  },
});

export default (state = initialState, action) => (
  reducerMap[action.type] ? reducerMap[action.type](state, action) : state
);